import { permissionObj } from '../../../../Helpers/permission';
import SearchSimple from '../../../../components/SearchSimples/SearchSimple';
import CustomTable from "../../../../components/table/CustomTable";
import CustomButtonLink from "../../../../components/buttons/CustomButtonLink";
import {MaterialRequestTableApp} from "../Functionality/MaterialRequestTableApp";
import routes from "../../../../Routes/routes";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const MaterialRequestTable = ({
    selectedList,
    setSelectedList,
    isAllChecked,
    setIsAllChecked,
    option,
    setBodyForExport,
    searchElement,
    setSearchElement,
    setSearch,
    setSimpleSearch
}) => {
    const {
        t,
        navigate,
        handleDeleteAll,
        permission,
        DEV,
        tableId,
        searchId,
        thead,
        tbody,
        handleCheckboxChange,
        getActionsButtons,
        pagination,
        rowsPerPage,
        setResults,
        deletePermission
    } = MaterialRequestTableApp({
        selectedList,
        setSelectedList,
        setIsAllChecked,
        option,
        setBodyForExport,
        searchElement,
    });

    return (
        <>
            <SearchSimple
                id={"txt_mrt_search_simple"}
                setBodyForExport={setBodyForExport}
                setSearchResults={setResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                optionTable={option}
                rowsPerPage={rowsPerPage}
                setSearch={setSearch}
                setSimpleSearch={setSimpleSearch}
                contractorId={null}
                supplierId={null}
            />
            <CustomTable tableId={tableId}
                         searchId={searchId}
                         checkbox={deletePermission}
                         checkboxTitle={"de_/_select_all"}
                         isAllChecked={isAllChecked}
                         onChangeCheckbox={handleDeleteAll}
                         thead={thead}
                         tbody={tbody}
                         columnActions={true}
                         getActionsButtons={getActionsButtons}
                         handleCheckboxChange={handleCheckboxChange}
                         selectedList={selectedList}
                         childrenNotInformation={tbody?.data?.length === 0 ? <>
                                 <div className={"warning-text"}>
                                     <p>{t("you_dont_have_any_requests_yet")}</p>
                                 </div>
                                 { (DEV || permission?.includes(permissionObj?.WEB_MATERIAL_REQUEST_CREATE)) &&
                                 <CustomButtonLink splitName={false} id={'btn_mrt_create'} card={true}
                                                   onClick={() => navigate(routes.materialRequest.create)}
                                                   name={'create_new_request'}/>
                                 } </>
                             : undefined
                         }
            />
            {pagination()}
        </>
    );
};

export default MaterialRequestTable;
